import { useContext, useState } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import {
  AppBar,
  Avatar,
  Box,
  Divider,
  Drawer,
  IconButton,
  List,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  ListSubheader,
  Menu,
  MenuItem,
  Toolbar,
  Tooltip,
  Typography,
} from '@mui/material'
import MenuIcon from '@mui/icons-material/Menu'
import LogoutIcon from '@mui/icons-material/Logout'
import { Context } from '../../context/AuthContext'
import { MENU_GROUPS } from '../../const/menu'
import PermissionComponent from '../../permissions'

const DRAWER_WIDTH = 280

const Header = () => {
  const { userName, userEmail, companyName, urlLogo, handleLogout, colorPrimary } =
    useContext(Context)
  const navigate = useNavigate()
  const location = useLocation()

  const [drawerOpen, setDrawerOpen] = useState(false)
  const [anchorEl, setAnchorEl] = useState(null)

  const initials = (userName || '?')
    .split(' ')
    .filter(Boolean)
    .slice(0, 2)
    .map(part => part[0])
    .join('')
    .toUpperCase()

  const go = item => {
    setDrawerOpen(false)
    if (item.external) {
      window.location.href = item.href
      return
    }
    navigate(item.path)
  }

  const onLogout = async () => {
    setAnchorEl(null)
    await handleLogout()
    navigate('/Login')
  }

  const drawerContent = (
    <Box sx={{ width: DRAWER_WIDTH }} role="navigation">
      <Box sx={{ p: 2, display: 'flex', alignItems: 'center', gap: 1.5, minHeight: 72 }}>
        {urlLogo ? (
          <Box component="img" src={urlLogo} alt={companyName} sx={{ maxWidth: 160, maxHeight: 40 }} />
        ) : (
          <Typography variant="subtitle1" fontWeight={600}>
            {companyName}
          </Typography>
        )}
      </Box>
      <Divider />
      {MENU_GROUPS.map(group => (
        <List
          key={group.title}
          dense
          subheader={
            <ListSubheader disableSticky sx={{ fontWeight: 600, letterSpacing: 0.5 }}>
              {group.title.toUpperCase()}
            </ListSubheader>
          }
        >
          {group.items.map(item => {
            const Icon = item.icon
            const selected =
              !item.external && location.pathname.toLowerCase().startsWith(item.path.toLowerCase())
            return (
              <PermissionComponent permissao={item.permissao} key={item.path || item.href}>
                <ListItemButton selected={selected} onClick={() => go(item)} sx={{ pl: 3 }}>
                  <ListItemIcon sx={{ minWidth: 38 }}>
                    <Icon fontSize="small" color={selected ? 'primary' : 'inherit'} />
                  </ListItemIcon>
                  <ListItemText primary={item.label} />
                </ListItemButton>
              </PermissionComponent>
            )
          })}
        </List>
      ))}
    </Box>
  )

  return (
    <>
      <AppBar position="sticky" sx={{ bgcolor: colorPrimary }} elevation={1}>
        <Toolbar>
          <IconButton color="inherit" edge="start" onClick={() => setDrawerOpen(true)} sx={{ mr: 2 }}>
            <MenuIcon />
          </IconButton>
          <Typography
            variant="h6"
            noWrap
            sx={{ flexGrow: 1, cursor: 'pointer' }}
            onClick={() => navigate('/dashboard')}
          >
            Controle de Produção
          </Typography>
          <Tooltip title={userEmail || ''}>
            <IconButton onClick={event => setAnchorEl(event.currentTarget)} sx={{ p: 0.5 }}>
              <Avatar sx={{ width: 34, height: 34, bgcolor: 'rgba(255,255,255,0.25)' }}>
                <Typography variant="body2" color="#fff">
                  {initials}
                </Typography>
              </Avatar>
            </IconButton>
          </Tooltip>
          <Menu anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={() => setAnchorEl(null)}>
            <Box sx={{ px: 2, py: 1 }}>
              <Typography variant="subtitle2">{userName}</Typography>
              <Typography variant="caption" color="text.secondary">
                {userEmail}
              </Typography>
            </Box>
            <Divider />
            <MenuItem onClick={onLogout}>
              <ListItemIcon>
                <LogoutIcon fontSize="small" />
              </ListItemIcon>
              Sair
            </MenuItem>
          </Menu>
        </Toolbar>
      </AppBar>
      <Drawer open={drawerOpen} onClose={() => setDrawerOpen(false)}>
        {drawerContent}
      </Drawer>
    </>
  )
}

export default Header
